import { getResponseHeader } from '~/lib/utils/fetch';

export const useTrophyRevealFromHeader = async (response) => {
  const trophyHeader = getResponseHeader(response, AdamHeader.NomadTrophies);

  const lowPrioTrophiesHeader = getResponseHeader(
    response,
    AdamHeader.NomadLowPrioTrophies
  );

  const notificationsStore = useNotificationsStore();
  const dialogTrophyFromHeader = useDialogTrophyFromHeader();
  if (!trophyHeader) return;

  const trophiesIds = trophyHeader.split(',').map((id) => id.trim());

  let lowPrioIds = [];
  if (lowPrioTrophiesHeader) {
    lowPrioIds = lowPrioTrophiesHeader.split(',').map((id) => id.trim());
  }

  const dialogTrophieIds = trophiesIds.filter((id) => !lowPrioIds.includes(id));
  if (dialogTrophieIds.length > 0) {
    dialogTrophyFromHeader.open(dialogTrophieIds);
  }

  if (lowPrioIds) {
    notificationsStore.push(NotificationTypes.Trophies, lowPrioIds);
  }
};
